export const ETIQUETA_COMIDA = 'Comida';
export const ETIQUETA_CENA = 'Cena';

export function esPlatoSinReceta(plato) {
  return plato === ETIQUETA_COMIDA || plato === ETIQUETA_CENA;
}

export function usosItem(item) {
  if (!item) return [];
  if (Array.isArray(item.usos) && item.usos.length) {
    return item.usos.map((u) => String(u || '').trim()).filter(Boolean);
  }
  if (item.origen === 'fijo') return [];
  const raw = String(item.plato || '').trim();
  if (!raw) return [];
  return raw
    .split(' | ')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function etiquetaOrigenItem(item) {
  if (!item) return '';
  if (item.origen === 'fijo') return 'Siempre';
  const usos = usosItem(item);
  if (usos.length) return usos.join(' · ');
  if (esPlatoSinReceta(item.plato)) return item.plato;
  if (item.plato) return item.plato;
  return '';
}

export function etiquetaAnadidoPor(item) {
  if (!item) return '';
  if (item.origen === 'menu' || item.origen === 'fijo') return 'Automático';
  if (item.anadidoPor && item.anadidoPor !== 'Manual' && item.anadidoPor !== 'Automático') {
    return item.anadidoPor;
  }
  return item.createdBy || 'Manual';
}

function mismoDiaLocal(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

const WEEKDAYS_ES = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
const MESES_CORTOS_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];

function weekdayDeFecha(fecha, weekdayHint) {
  const hint = String(weekdayHint || '')
    .trim()
    .toLowerCase();
  if (hint && hint !== 'hoy' && hint !== 'mañana' && hint !== 'pasado') return hint;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(fecha || ''))) return '';
  const d = new Date(`${fecha}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  const iso = d.getDay() === 0 ? 6 : d.getDay() - 1;
  return WEEKDAYS_ES[iso] || '';
}

function fechaCortaEs(fecha) {
  const parts = String(fecha || '').split('-').map((n) => parseInt(n, 10));
  if (parts.length !== 3 || parts.some((n) => !Number.isInteger(n))) return '';
  const [, month, day] = parts;
  if (month < 1 || month > 12 || day < 1 || day > 31) return '';
  return `${day} ${MESES_CORTOS_ES[month - 1]}`;
}

export function etiquetaDiaMenu(dia, hoy) {
  const fecha = String(dia?.fecha || '');
  const weekday = weekdayDeFecha(fecha, dia?.weekday);
  const weekdayCap = weekday ? weekday.charAt(0).toLocaleUpperCase('es-ES') + weekday.slice(1) : '';
  const corta = fechaCortaEs(fecha);
  const base = [weekdayCap, corta].filter(Boolean).join(' ');
  if (fecha && fecha === hoy) return base ? `${base} (hoy)` : 'Hoy';
  return base || fecha;
}

export function resumenPlatosDia(dia) {
  return [dia?.desayuno, dia?.comida, dia?.cena]
    .map((s) => String(s || '').trim())
    .filter(Boolean)
    .join(' · ');
}

export function formatoFechaAnadido(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const hoy = new Date();
  if (mismoDiaLocal(d, hoy)) return 'hoy';
  const ayer = new Date(hoy);
  ayer.setDate(hoy.getDate() - 1);
  if (mismoDiaLocal(d, ayer)) return 'ayer';
  return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
}
